import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/admin/AdminSideMenu.css';

// 비활성화 아이콘 이미지 임포트
import companyIcon from '../../assets/admin/admin-company-icon.png';
import paymentIcon from '../../assets/admin/admin-payment-icon.png';
import refundIcon from '../../assets/admin/admin-refund-icon.png';
import revenueIcon from '../../assets/admin/admin-revenue-icon.png';

// 활성화 아이콘 이미지 임포트
import companyIconActive from '../../assets/admin/admin-company-icon-active.png';
import paymentIconActive from '../../assets/admin/admin-payment-icon-active.png';
import refundIconActive from '../../assets/admin/admin-refund-icon-active.png';
import revenueIconActive from '../../assets/admin/admin-revenue-icon-active.png';

const AdminSideMenu = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="adminSideMenu">
      <Link 
        to="/admin/company-list" 
        className={`adminMenuItem ${currentPath.includes('/company-list') ? 'active' : ''}`}
      >
        <span className="adminMenuIcon">
          <img 
            src={currentPath.includes('/company-list') ? companyIconActive : companyIcon} 
            alt="업체 관리"
            width="20"
            height="20"
          />
        </span>
        <span>업체 관리</span>
      </Link>
      
      <Link 
        to="/admin/revenue" 
        className={`adminMenuItem ${currentPath.includes('/revenue') ? 'active' : ''}`}
      >
        <span className="adminMenuIcon">
          <img 
            src={currentPath.includes('/revenue') ? paymentIconActive : paymentIcon} 
            alt="결제 관리"
            width="20"
            height="20"
          />
        </span>
        <span>결제 관리</span>
      </Link>
      
      <Link 
        to="/admin/support" 
        className={`adminMenuItem ${currentPath.includes('/support') ? 'active' : ''}`}
      >
        <span className="adminMenuIcon">
          <img 
            src={currentPath.includes('/support') ? refundIconActive : refundIcon} 
            alt="환불요청관리"
            width="20"
            height="20"
          />
        </span>
        <span>환불요청관리</span>
      </Link>
      
      <Link 
        to="/admin/settings" 
        className={`adminMenuItem ${currentPath.includes('/settings') ? 'active' : ''}`}
      >
        <span className="adminMenuIcon">
          <img 
            src={currentPath.includes('/settings') ? revenueIconActive : revenueIcon} 
            alt="수익 관리"
            width="20"
            height="20"
          />
        </span>
        <span>수익 관리</span>
      </Link>
    </div>
  );
};

export default AdminSideMenu; 